export default __webpack_public_path__ + "static/media/gallery-26.e1b3f40f.jpg";